import { Component, Input } from '@angular/core';
import { Airport } from '../models/airport.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';


@Component({
  selector: 'app-activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.scss']
})
export class ActivityDetailComponent {
  @Input() airport: Airport;

  toc: QuickNavToc = new QuickNavToc('airport-quicknav', [{
    label: 'Overview',
    fragment: 'overview',
    visible: true
  }, {
    label: 'Local Activities',
    fragment: 'activities',
    visible: true
  }, {
    label: 'Airport Reviews',
    fragment: 'reviews',
    visible: true
  }]);

  constructor() { }
}
